import { z } from "zod"

export const MarkChatsAsReadSchema = z
  .object({
    storeId: z.guid(),
    jobIds: z.array(z.guid()),
    storeCustomerIds: z.array(z.guid()).default([]),
  })
  .refine((value) => value.jobIds.length + value.storeCustomerIds.length > 0, {
    message: "At least one chat must be given",
  })

export type MarkChatsAsRead = z.infer<typeof MarkChatsAsReadSchema>
